import { cn } from "../../helpers"

const tabsList = (className?: string) => cn("flex rounded-2xl bg-white", className)
const tabsTrigger = (className?: string) =>
  cn(
    "px-2 py-3 sm:px-4 sm:py-5 flex-1 items-center justify-center whitespace-nowrap first:rounded-l-2xl last:rounded-r-2xl outline outline-1 outline-neutral-200 -outline-offset-1 -ml-px first:ml-0 transition-all",
    "data-[state=active]:outline-blurple-500 data-[state=active]:outline-2 data-[state=active]:-outline-offset-2 data-[state=active]:z-20",
    "hover:bg-neutral-50 hover:outline-2 hover:outline-neutral-300 hover:-outline-offset-2 hover:z-10",
    "active:bg-neutral-50 active:outline-2 active:outline-neutral-300 active:-outline-offset-2 active:z-10",
    "focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blurple-600",
    "disabled:pointer-events-none disabled:opacity-50",
    className,
  )
const tabsContent = (className?: string) => cn("mt-6", className)

export { tabsList, tabsTrigger, tabsContent }
